<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import UserPassword from '../../../user/components/UserPassword.vue'

definePage({
  meta: {
    requiresAuth: true,
    hideLeftColumn: true,
    hideRightColumn: true,
  },
})
</script>

<template>
  <UserPassword />
</template>
